export const apiKeys = {
  MAPBOX_ACCESS_TOKEN: 'pk.eyJ1IjoiYXR1cjI0IiwiYSI6ImNsOW9wejNrcTBpamgzdmw4eGY4emtzbG4ifQ.6CabKWe9pgePiaHzESjAhw',
  GMAP_API_Key: 'AIzaSyBU16E1Zmvvi3wP3gYK2ucjY53c9_7PZI4',
  GOOGLE_CLIENT_ID: '206844219428-gbfago9cv6bdppdpjgarpldkfjkval72.apps.googleusercontent.com',
  LOCATION_FILTER_KEY: 'am9BMTlaczIzaEw0alVabXBBcWZpRkJibm03UmZUSmMxMmU4dHZXMg=='
};

